<template>
    <div id="aprication">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>

             </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" @click="handleView" style=";background-color:#409EFF;color: white;">
                        查看<i class="el-icon-search"></i></el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" v-if="$hasPerm('business:dicKm:add')" @click="handleDelete()"
                               style=";background-color:#ff1f29;color: white">删除<i class="el-icon-delete"></i>
                    </el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" v-if="$hasPerm('business:dicKm:add')" @click="handleEdit()"
                               style=";background-color:#f59523;color: white">修改<i class="el-icon-edit-outline"></i>
                    </el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" v-if="$hasPerm('business:dicKm:add')" @click="handleAdd()"
                               style=";background-color:#16E3A1;color: white">新增<i class="el-icon-plus"></i></el-button>
                </div>
            </div>
        </div>

        <div style="width: 100%;height: 100%;display:flex;flex-direction:column;">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="资产" name="ZC"></el-tab-pane>
                <el-tab-pane label="负债" name="FZ"></el-tab-pane>
                <el-tab-pane label="权益" name="QY"></el-tab-pane>
                <el-tab-pane label="成本" name="CB"></el-tab-pane>
                <el-tab-pane label="损益" name="SY"></el-tab-pane>
            </el-tabs>
        </div>

        <div class="ch_panel" id="queryDiv2" style="height: 460px; overflow: auto;color: #73d7b7">
            <div id="kmTree" class="ztree" style="background-color: white;"></div>
        </div>

        <edit v-if="editVisible" ref="edit" @getMgrTree="getMgrTree"></edit>
    </div>
</template>
<script>
    import Edit from './edit'
    import $ from 'jquery'

    export default {
        name: 'dicKmList',
        components: {
            Edit
        },
        data() {
            return {
                tableData: [],
                activeName: 'ZC',
                defaultSetting: {
                    data: {
                        simpleData: {
                            enable: true
                        }
                    },
                    view: {
                        selectedMulti: false
                    },
                    callback: {
                        onDblClick: this.zTreeOnDblClick
                    }
                },
                markName: '',
                editVisible: false
            }
        },
        methods: {
            getMgrTree(leiBie) {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/dicKm/getMgrTree'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'leiBie': leiBie
                    })
                }).then(r => {

                    $("#kmTree").html("");
                    $.fn.zTree.init($("#kmTree"), this.defaultSetting, r.data.data);

                    //全部节点都要展开
                    let treeObj = $.fn.zTree.getZTreeObj("kmTree");
                    treeObj.expandAll(true);

                }).finally(r => {
                })
            },
            handleClick(tab) {
                //科目分类 ZC:资产、FZ:负债、QY:权益、CB:成本、SY:损益
                this.getMgrTree(tab.name);
            },
            getSelectedNodeData(type) {//获取选中节点的ID
                let treeObj = $.fn.zTree.getZTreeObj("kmTree");
                let nodes = treeObj.getSelectedNodes();
                if (nodes.length != 1) {
                    return '';
                }
                if (type == 1) {
                    return nodes[0].dicCode;
                }
                if (type == 2) {
                    return nodes[0].id;
                }

            },
            handleAdd() {
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int("1", null, this.getSelectedNodeData(1), this.activeName);
                })
            },
            handleEdit() {
                let id = this.getSelectedNodeData(2);
                if (id == '') {
                    this.$message({ // 失败
                        type: 'warning',
                        message: "请选择一个节点！"
                    })
                    return false;
                }
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int("2", id, this.getSelectedNodeData(1), this.activeName);
                })
            },
            handleView() {
                let id = this.getSelectedNodeData(2);
                if (id == '') {
                    this.$message({ // 失败
                        type: 'warning',
                        message: "请选择一个节点！"
                    })
                    return false;
                }
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int("3", id, this.getSelectedNodeData(1), this.activeName);
                })
            },
            handleDelete() {
                let id = this.getSelectedNodeData(2);
                if (id == '') {
                    this.$message({ // 失败
                        type: 'warning',
                        message: "请选择一个节点！"
                    })
                    return false;
                }
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/dicKm/remove'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'id': id
                    })
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.getMgrTree(this.activeName);
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {
                })
            },
            zTreeOnDblClick(event, treeId, treeNode) {
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int("3", treeNode.id, treeNode.dicCode, this.activeName);
                })
            }
        },
        created: function () {
            this.getMgrTree("ZC");
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }
</style>